



















































import VueOptions from '@utils/VueOptions'
import IndicatorUtility from '@utils/IndicatorUtility'

settings =
  name: 'AudienceListingFeedCard'

  vue:
    props: ['items', 'actions']

    computed:
      indicators: ->
        Object.values(@items)
      trustedIndicators: ->
        @indicators.filter((i) -> i.trusted).sort((a, b) ->
          if a.data is b.data then 0 else if b.data is 'empty' then -1 else 1
        )
      untrustedIndicators: ->
        @indicators.filter((i) -> not i.trusted).sort((a, b) ->
          if a.data is b.data then 0 else if b.data is 'empty' then -1 else 1
        )

    methods:
      hitrustedHover: (event) ->
        event.currentTarget.classList.add('uncollapsed')
      hiUntrustedLeave: (event) ->
        event.currentTarget.classList.remove('uncollapsed')

      hiNavToIndicatorResource: (indicator) ->
        { name, params, query } = IndicatorUtility.routeFor indicator
        { href } = @$router.resolve { name, params, query }
        window.open href, '_blank'

      tooltipFor: (indicator) ->
        tooltip = "#{@formatTitle(indicator.indicator_key)} | #{@formatTitle(indicator.status)}"
        tooltip += " | #{indicator.message}" if indicator.message and indicator.data is 'set'
        tooltip

      iconFor: (indicator) ->
        IndicatorUtility.iconFor indicator

      statusFor: (indicator) ->
        IndicatorUtility.statusFor indicator

      formatTitle: (value) ->
        @$options.filters.formatTitle value

      formatDateTime: (date) ->
        dayjs(date).format('MM-DD-YYYY HH:mm')

export default VueOptions.vue settings
